import clsx from 'clsx';
import React from 'react';
import { polymorphicFactory } from '../../factory/factory.utils.mjs';
import { Box } from '../../Other/Box/Box.mjs';
import classes from './Spacer.module.css.mjs';
import { spacerSizeClasses } from './Spacer.utils.mjs';

const Spacer = polymorphicFactory(
  (props, ref) => {
    const { component = "div", className, size = "xs", ...rest } = props;
    const classNames = clsx("kohler-spacer-root", className, classes.root, spacerSizeClasses[size]);
    return /* @__PURE__ */ React.createElement(Box, { className: classNames, component, ref, ...rest });
  }
);

export { Spacer };
